import * as R from 'ramda';
import { DEFAULT_USER_PRIVIILEGES } from 'App/features/UserManager/constants';

const trimIfExists = R.ifElse(R.is(String), R.trim, R.identity);

function mapValuesForSubmit(values) {
    const roles = values.roles.map(R.pick(['roleId']));

    const { branches, privileges } = values.branches.reduce(
        (result, branch) => {
            result.branches.push({ id: branch.id });

            const privs = R.compose(
                R.assoc('branchId', branch.id),
                R.mergeRight(DEFAULT_USER_PRIVIILEGES),
                R.mapObjIndexed(R.T),
                R.indexBy(R.prop('value'))
            )(branch.privileges);

            if (values.isCompanyAdmin) {
                privs.companyAdmin = true;
            }

            if (values.reporting?.value === 'Report Builder') {
                privs.reportBuilder = true;
            }

            if (values.reporting?.value === 'Report Viewer') {
                privs.reportViewer = true;
            }

            result.privileges.push(privs);

            return result;
        },
        { branches: [], privileges: [] }
    );

    return R.compose(
        R.assoc('privileges', privileges),
        R.assoc('roles', roles),
        R.assoc('branches', branches),
        R.over(R.lensProp('firstName'), trimIfExists),
        R.over(R.lensProp('lastName'), trimIfExists),
        R.over(R.lensProp('suffix'), trimIfExists),
        R.over(R.lensProp('email'), trimIfExists),
        R.pick(['firstName', 'lastName', 'email', 'suffix'])
    )(values);
}

export default mapValuesForSubmit;
